(function () {
  function initMasonryGrid(grid) {
    if (!window.jQuery || !jQuery.fn.masonry) return;

    // avoid double-binding
    if (grid.dataset.masonryBound === "1") return;
    grid.dataset.masonryBound = "1";

    var $grid = jQuery(grid);
    var sizer = grid.querySelector("[class^='grid-sizer-']");

    var options = {
      itemSelector: ".ms-item",
      percentPosition: true
    };

    if (sizer) {
      options.columnWidth = sizer;
    }

    function layout() {
      try {
        // init (safe even if already initialized)
        $grid.masonry(options);
      } catch (e) {
        // swallow
      }

      try {
        $grid.masonry("layout");
      } catch (e) {
        // swallow
      }
    }

    // images
    try {
      $grid.imagesLoaded(function () {
        layout();
      });
    } catch (e) {
      // if imagesLoaded is not present, just run layout
      layout();
    }

    // iframes (maps etc.)
    grid.querySelectorAll("iframe").forEach(function (frame) {
      frame.addEventListener("load", function () {
        try {
          $grid.masonry("layout");
        } catch (e) {}
      });
    });

    // final fallback after any async content
    setTimeout(function () {
      try {
        $grid.masonry("layout");
      } catch (e) {}
    }, 1500);
  }

  function initAllMasonryGrids() {
    if (!window.jQuery || !jQuery.fn.masonry) {
      // keep waiting until masonry plugin is actually there
      setTimeout(initAllMasonryGrids, 50);
      return;
    }

    document
      .querySelectorAll(".grid-masonary")
      .forEach(function (grid) { initMasonryGrid(grid); });
  }

  // run once DOM is ready (and also if this file loads after DOMContentLoaded)
  if (document.readyState === "complete" || document.readyState === "interactive") {
    initAllMasonryGrids();
  } else {
    document.addEventListener("DOMContentLoaded", initAllMasonryGrids);
  }

  // re-run when sections are reloaded in the theme editor
  document.addEventListener("shopify:section:load", function (evt) {
    if (!evt.target) return;
    evt.target
      .querySelectorAll(".grid-masonary")
      .forEach(function (grid) { initMasonryGrid(grid); });
  });
})();
